<script lang="ts">
    import {onMount} from "svelte";
    import SorryMessageView from "../../../component/common/Message/SorryMessageView.svelte";
    import LabelValueView from "../../../component/common/Value/LabelValueView.svelte";
    import {SpaceTable} from "../../../lib/Table/SpaceTable";
    import SpaceSettingEditView from "./SpaceSettingEditView.svelte";
    import LinkButtonView from "../../../component/common/Button/LinkButtonView.svelte";
    import SpaceLoadView from "../../../component/Space/SpaceLoadView.svelte";
    import HeadingTitleView from "../../../component/common/Typography/HeadingTitleView.svelte";

    export let params = {};

    $: hasManageAuthority = (() => {
        return SpaceTable.hasManage(space);
    })();

    onMount(() => {
    });

    let space = null;


    function onLoadSpace(event) {
        space = event.detail.space;


    }


</script>

<div class="space-edit-page standard-page">
    <SpaceLoadView spaceUniqueId={params['space_unique_id']}
                   on:load={onLoadSpace}
    >

        <div class="space-edit-content">
            <div>

                <HeadingTitleView title="スペース設定">
                    <div slot="right">
                        <LinkButtonView fontAwesomeIcon="users-gear" text="権限管理"
                                        url={`/#/space/${space.unique_id}/permission`}/>


                    </div>

                </HeadingTitleView>

                <div>
                    <LabelValueView label="スペースID" value={space.id}/>
                    <LabelValueView label="スペース名" value={space.name}/>
                </div>
            </div>

            <div>


            </div>

            {#if hasManageAuthority}
                <div class="edit-area">
                    <SpaceSettingEditView space={space}/>
                </div>
            {:else}
                <SorryMessageView message="権限がありません"/>
            {/if}

        </div>


    </SpaceLoadView>


</div>
<style lang="scss">
    .space-edit-page {
        .space-edit-content {
            display: flex;
            flex-direction: column;
            gap: 32px;
        }

    }
</style>